import { Directive, ElementRef, Host, Optional, Renderer2 } from "@angular/core";
import { NzDropdownButtonDirective } from "ng-zorro-antd/dropdown";
import { UiButtonGroupComponent } from "@webapp/ui/button/components/button-group/button-group.component";

@Directive({
  selector: "[ui-button][ui-dropdown]",
})
export class UiDropdownButtonDirective extends NzDropdownButtonDirective {
  constructor(renderer: Renderer2, @Host() @Optional() uiButtonGroupComponent: UiButtonGroupComponent, elementRef: ElementRef) {
    super(renderer, uiButtonGroupComponent, elementRef);
  }
}
